module.exports = __webpack_public_path__ + "img/logo-firefox.b8de11cc.png";